import * as React from 'react'

const Button = React.forwardRef(({ className = '', variant = 'default', size = 'default', ...props }, ref) => {
  const v = variant === 'destructive' ? 'btn-danger'
    : variant === 'outline' ? ''
    : variant === 'ghost' ? 'btn-ghost'
    : variant === 'secondary' ? ''
    : 'btn-primary'
  const s = size === 'sm' ? 'btn-sm'
    : size === 'lg' ? 'btn-lg'
    : size === 'icon' ? 'btn-icon'
    : ''
  return (
    <button
      ref={ref}
      className={['btn', v, s, className].filter(Boolean).join(' ')}
      {...props}
    />
  )
})
Button.displayName = 'Button'

export { Button }
